module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "tooltipsfade"
    }
  }, [(_vm.tooltipsvisible) ? _c('div', {
    staticClass: "tooltips",
    class: {
      transparent: _vm.isTransparent, extended: !!_vm.extended, webgl: !!_vm.webgl
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "tooltips_header"
  }, [_c('span', {
    staticClass: "helpimg h7 regular c-dark"
  }, [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "help bold c-light h7"
  }, [_vm._v(_vm._s(_vm.$t('aiuto')) + " ")])]), _vm._v(" "), (typeof _vm.box !== 'undefined') ? _c('div', {
    staticClass: "tooltips_box",
    domProps: {
      "innerHTML": _vm._s(_vm.box)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tooltips_container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "tooltips_bottombar"
  }, [_c('span', {
    staticClass: "h7 regular"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('problems')) + " \n            "), _c('a', {
    staticClass: "c-accent",
    attrs: {
      "href": 'mailto:' + _vm.$store.state.email
    }
  }, [_vm._v(_vm._s(_vm.$t('say')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "close_btn h7 bold c-dark upcase"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('understand')) + " "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753af7d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/tooltips.vue
// module id = 645
// module chunks = 0